import {
  categoriesFiltersSort,
  categoryNames,
  filtersSubCategories,
  getListOptions,
} from "../../../Findings/FindingsFilters/FilterRow/FilterRowUtils";
import type { FieldData } from "../../FilterManagement/CommonFilterTypes";
import { sortFieldsByDatasource } from "./sortFieldsByDatasource";

export const additionalDataCategoryField = filtersSubCategories.find(
  (subCategory) => subCategory.name === categoryNames.ADDITIONAL_DATA
)?.field;

export const generalCategoryField = filtersSubCategories.find(
  (subCategory) => subCategory.name === categoryNames.GENERAL
)?.field;

// Shape produced by the untyped `getListOptions` util: each selectable field is
// a `FieldData` spread with a derived `label` and `value` (the field name).
export interface FilterFieldOption extends FieldData {
  label?: string;
  value: string;
}

// Category grouping returned by `getListOptions` for the collapsed (non-search) view.
export interface FilterFieldCategory {
  field: string;
  label: string;
  value: string;
  isMenu: boolean;
  subItems: FilterFieldOption[];
}

export const groupFieldsByCategory = (
  fields: FieldData[] | undefined
): FilterFieldCategory[] =>
  ((getListOptions(fields, true) ?? []) as FilterFieldCategory[])
    .sort(
      (a, b) =>
        categoriesFiltersSort.indexOf(a.field) -
        categoriesFiltersSort.indexOf(b.field)
    )
    .map((category) =>
      category.field === additionalDataCategoryField
        ? { ...category, subItems: sortFieldsByDatasource(category.subItems) }
        : category
    );
